import { useEffect, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import { api } from '../../lib/api.js';
import WebBrief from '../../components/brief/WebBrief.jsx';

export default function ArchiveEdition() {
  const { date } = useParams();
  const [state, setState] = useState({ status: 'loading', edition: null, error: null });

  useEffect(() => {
    let cancelled = false;
    setState({ status: 'loading', edition: null, error: null });
    (async () => {
      try {
        const data = await api.get(`/archive/editions/${encodeURIComponent(date)}`);
        if (!cancelled) {
          setState({ status: 'ready', edition: data?.edition || null, error: null });
        }
      } catch (err) {
        if (!cancelled) {
          setState({ status: 'error', edition: null, error: err.message });
        }
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [date]);

  const { status, edition, error } = state;
  const isoDate = edition?.isoDate || date;
  const briefPath = `/archive/${isoDate}`;
  const ready = status === 'ready' && Boolean(edition);
  const hasArticles = (edition?.articles || []).length > 0;

  return (
    <div className="max-w-page mx-auto px-4 sm:px-6 py-8">
      <div className="w-full mb-6 text-[13px]">
        <Link to="/archive" className="text-hxd-orange font-semibold hover:underline">
          ← Back to Archive
        </Link>
      </div>

      {status === 'loading' && (
        <p className="text-[13px] text-hxd-muted italic text-center">Loading edition…</p>
      )}

      {status === 'error' && (
        <p className="text-[13px] text-red-600 text-center">
          Couldn&apos;t load this edition: {error}
        </p>
      )}

      {ready && !hasArticles && (
        <p className="text-[13px] text-hxd-muted italic text-center">
          No articles to show for this edition.
        </p>
      )}

      {ready && (
        <WebBrief edition={edition} briefPath={briefPath} ready />
      )}
    </div>
  );
}
